:host {
  --caption-opacity: 1;

  ::slotted(*) {
    max-width: 100%;
  }
}

:host([fullwidth]:not([fullwidth="false"])) ::slotted(:not(map)) {
  width: 100%;
}

.stzh-figure {
  display: flex;
  flex-direction: column;
  margin: 0;

  &__element {
    display: flex;

    @media print {
      page-break-inside: avoid;
      break-inside: avoid;
    }
  }

  &__caption-wrapper {
    @include fontCurve('caption');
    display: flex;
    flex-direction: column;
    opacity: var(--caption-opacity);
    transition: opacity $baseTransitionAnimationSpeed;
  }

  &__heading-wrapper {
    display: flow-root;
  }

  &__counter {
    float: left;
    color: $colorSecondary60;

    &:not(:empty) {
      margin-right: space('xsmall');
    }
  }

  &__counter,
  &__heading {
    @include font('heavy');
    display: block;
  }

  &__copyright {
    @include font;
    @include fontSize('femto');
    color: $colorGrey80;

    &:not(:empty) {
      margin-top: space('xxsmall');
    }
  }

  /* Has caption content */

  &--has-caption &__caption-wrapper {
    margin-top: space('small');
  }
}
